
import React from 'react';
import { Separator } from '@/components/ui/separator';
import { NavBarTimeFrame } from '../NavBarTimeFrame';
import { TimeFrameOption } from '@/components/business/leads/utils/dateFilters';

interface TimeFrameSectionProps {
  timeFrame?: TimeFrameOption | string;
  onTimeFrameChange?: (value: TimeFrameOption) => void;
}

export const TimeFrameSection: React.FC<TimeFrameSectionProps> = ({
  timeFrame,
  onTimeFrameChange
}) => {
  if (!onTimeFrameChange || !timeFrame) return null;
  
  return (
    <div className="flex items-center space-x-2">
      <Separator 
        orientation="vertical" 
        className="h-8 bg-gray-300 mx-2" 
      />
      <label className="text-sm text-gray-600 whitespace-nowrap">
        Filter Timeframe:
      </label>
      <NavBarTimeFrame
        timeFrame={timeFrame}
        onTimeFrameChange={onTimeFrameChange}
      />
    </div>
  );
};
